"use client";

import React from "react";
import { Wheat, Droplet, Sprout, Award } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const ingredients = [{
  title: "Certified Roofing",
  description: "Master-level roofing installations featuring durable materials and technical precision to ensure a lifetime of weather protection and safety.",
  icon: Wheat,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/image_dgk9tjtb.jpg"
}, {
  title: "High-Flow Guttering",
  description: "Precision-engineered gutter and drainage systems that manage heavy rainfall with maximum efficiency, preventing structural water damage.",
  icon: Droplet,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/image_v5e1yimi.jpg"
}, {
  title: "Handcrafted Decks",
  description: "Custom-built outdoor living spaces utilizing high-performance composite and timber materials for enduring structural integrity and luxury.",
  icon: Sprout,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/image_weach2lh.jpg"
}, {
  title: "Siding Systems",
  description: "Architectural-grade vinyl siding designed for superior thermal insulation and a sharp, modern profile that protects your home's structural envelope.",
  icon: Award,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/image_gem0o6qi.jpg"
}];
export default function OurSecretIngredients() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223996" id="our-core-expertise" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20 lg:mb-24">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tighter mb-6 text-foreground">
            Our Core Expertise
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl leading-relaxed font-sans">
            Protech Restoration LLC delivers high-end architectural protection through industrial precision, reliable materials, and expert craftsmanship.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {ingredients.map((item, i) => <div key={i} data-index={i} className={`group flex flex-col items-center text-center transition-all duration-700 ease-out hover:bg-muted/40 rounded-sm p-6 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <img src={item.image} alt={item.title} className="w-full aspect-video object-cover mb-6 rounded-sm shadow-sm" />
              <h3 className="font-default text-xl font-bold mb-4 text-foreground tracking-tight">
                {item.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed font-sans text-sm md:text-base">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}